import { Observable } from 'rxjs'

export abstract class BulkActivateExternalDataService {
  abstract bulkActivateNewerData(
    beginReconDate: string,
    endReconDate: string,
    accountIds: string,
    dataSourceType: string,
  ): Observable<void>
}
